module.exports = __webpack_public_path__ + "img/R@2x.f909489a.png";